// Icônes de la landing claire. Monoline, trait 1.8, arrondies. Bleu ou gris
// selon le contexte (couleur héritée).
const b = {
  width: 22, height: 22, viewBox: '0 0 24 24', fill: 'none',
  stroke: 'currentColor', strokeWidth: 1.8,
  strokeLinecap: 'round', strokeLinejoin: 'round'
}

export const Lock = p => (
  <svg {...b} {...p}>
    <rect x="4.5" y="10.5" width="15" height="10" rx="2.5" />
    <path d="M8 10.5V8a4 4 0 0 1 8 0v2.5M12 14.5v2.5" />
  </svg>
)

export const Shield = p => (
  <svg {...b} {...p}>
    <path d="M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3Z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
)

export const Phone = p => (
  <svg {...b} {...p}>
    <rect x="7" y="2.5" width="10" height="19" rx="2.4" />
    <path d="M10.5 18.2h3" />
  </svg>
)

export const Globe = p => (
  <svg {...b} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M3 12h18M12 3c2.6 2.8 3.8 5.8 3.8 9s-1.2 6.2-3.8 9c-2.6-2.8-3.8-5.8-3.8-9S9.4 5.8 12 3Z" />
  </svg>
)

export const EyeOff = p => (
  <svg {...b} {...p}>
    <path d="M4 4l16 16" />
    <path d="M10 5.3a10 10 0 0 1 2-.2c5 0 8.6 3.9 9.6 6.9-.5 1.5-1.5 3-2.9 4.2M6.4 6.5C4.4 7.8 3 9.8 2.4 12c1 3 4.6 6.9 9.6 6.9 1.4 0 2.8-.3 4-.9" />
    <path d="M9.5 9.7a3.5 3.5 0 0 0 4.8 4.9" />
  </svg>
)

export const Clock = p => (
  <svg {...b} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7.5V12l3 1.8" />
  </svg>
)

export const Moon = p => (
  <svg {...b} {...p}>
    <path d="M20 14.5A8.5 8.5 0 0 1 9.5 4a8.5 8.5 0 1 0 10.5 10.5Z" />
  </svg>
)

export const Ban = p => (
  <svg {...b} {...p}>
    <circle cx="12" cy="12" r="9" /><path d="M5.6 5.6l12.8 12.8" />
  </svg>
)

export const Check = p => (
  <svg {...b} {...p}>
    <path d="M4.5 12.5l5 5L19.5 7" />
  </svg>
)

export const Cross = p => (
  <svg {...b} {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
)

export const Battery = p => (
  <svg {...b} {...p}>
    <rect x="2.5" y="7" width="16" height="10" rx="2" />
    <path d="M21.5 10.5v3M5.5 10v4" />
  </svg>
)

export const Note = p => (
  <svg {...b} {...p}>
    <path d="M5 4.5h14v15H5z" />
    <path d="M8 9h8M8 12.5h8M8 16h5" />
  </svg>
)

export const Route = p => (
  <svg {...b} {...p}>
    <circle cx="6" cy="18" r="2.5" /><circle cx="18" cy="6" r="2.5" />
    <path d="M8.5 18H14a3 3 0 0 0 0-6h-4a3 3 0 0 1 0-6h5.5" />
  </svg>
)

export const Menu = p => (
  <svg {...b} {...p}><path d="M4 7h16M4 12h16M4 17h16" /></svg>
)

export const Close = p => (
  <svg {...b} {...p}><path d="M6 6l12 12M18 6L6 18" /></svg>
)

export const Arrow = p => (
  <svg {...b} width="18" height="18" {...p}><path d="M5 12h14M13 6l6 6-6 6" /></svg>
)

export const Coin = p => (
  <svg {...b} {...p}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M14.5 9.3a3 3 0 0 0-2.5-1.3c-1.7 0-3 1.8-3 4s1.3 4 3 4a3 3 0 0 0 2.5-1.3" />
  </svg>
)

export const Play = p => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" {...p}>
    <path d="M8 5.5v13l11-6.5z" />
  </svg>
)

export const Apple = p => (
  <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M17.05 12.04c-.03-2.6 2.12-3.85 2.22-3.91-1.21-1.77-3.1-2.01-3.77-2.04-1.6-.16-3.13.94-3.94.94-.81 0-2.07-.92-3.4-.9-1.75.03-3.36 1.02-4.26 2.58-1.82 3.16-.47 7.84 1.3 10.41.86 1.26 1.89 2.67 3.24 2.62 1.3-.05 1.79-.84 3.36-.84 1.57 0 2.01.84 3.39.81 1.4-.02 2.29-1.28 3.15-2.55.99-1.46 1.4-2.87 1.42-2.94-.03-.01-2.73-1.05-2.76-4.16zM14.6 4.7c.72-.87 1.2-2.08 1.07-3.29-1.03.04-2.28.69-3.02 1.56-.66.77-1.24 2-1.08 3.18 1.15.09 2.32-.58 3.03-1.45z" />
  </svg>
)

export const Windows = p => (
  <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" aria-hidden="true" {...p}>
    <path d="M3 5.4 10.3 4.35v6.75H3zM11.25 4.2 21 2.8v8.3h-9.75zM3 12.9h7.3v6.75L3 18.6zM11.25 12.9H21v8.3l-9.75-1.4z" />
  </svg>
)
